export default {"src":"/_next/static/media/qr_box.9e17436b.svg","height":143,"width":148,"blurWidth":0,"blurHeight":0};